import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Zone } from 'types';
import { User } from 'types/api/users.type';

import type { RootState } from '../store';

type UserSliceState = {
  user?: User;
  zones: Zone[];
};

const initialState: UserSliceState = {
  user: undefined,
  zones: [],
};

export const userSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    // eslint-disable-next-line
    setUser: (state: UserSliceState, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    // eslint-disable-next-line
    setUserZones: (state: UserSliceState, action: PayloadAction<any>) => {
      state.zones = action.payload;
    },
    logout: () => {},
  },
});

export const { setUser, setUserZones, logout } = userSlice.actions;
export const selectUser = (state: RootState) => state.currentUser;
export const getUserZones = (state: RootState) => state.currentUser.zones;
